import { createAction } from 'redux-actions';

const ACTIONS_NAMESPACE = 'AUDIENCES_TABLE';

export const SET_AUDIENCES_ORDER_BY = `${ACTIONS_NAMESPACE}_SET_AUDIENCES_ORDER_BY`;

export const setAudiencesOrderBy = createAction(SET_AUDIENCES_ORDER_BY,
  audiencesOrderBy => ({ audiencesOrderBy }));
